import type {
  ApiCreateDayNoteDto,
  ApiDayNote,
  ApiDayNotesResponse,
  ApiUpdateDayNoteDto,
} from '@mfw/common';

import { destroy, patch, post, get } from './axios';

const base = (organizationId: string) =>
  `/v2/organizations/${organizationId}/day-notes`;

export interface FetchDayNotesArgs {
  organizationId: string;
  /** Civil days, both inclusive */
  from: string;
  to: string;
}

export const fetchDayNotes = ({
  organizationId,
  from,
  to,
}: FetchDayNotesArgs) =>
  get<ApiDayNotesResponse>(base(organizationId), { query: { from, to } });

export const createDayNote = ({
  organizationId,
  ...body
}: ApiCreateDayNoteDto & { organizationId: string }) =>
  post<ApiDayNote>(base(organizationId), body);

export const updateDayNote = ({
  organizationId,
  id,
  ...body
}: ApiUpdateDayNoteDto & { organizationId: string; id: string }) =>
  patch<ApiDayNote>(`${base(organizationId)}/${id}`, body);

export const deleteDayNote = ({
  organizationId,
  id,
}: {
  organizationId: string;
  id: string;
}) => destroy(`${base(organizationId)}/${id}`);
